import { FileOutlined } from "@ant-design/icons";
import { Col, Collapse, Row } from "antd";
import React, { useState } from "react";
import PdfPreview from "../../../biblio/Modal/PdfPreview";
interface Props {
  requests?: any;
}
const ShareList = ({ requests }: Props) => {
      const [pdfUrl, setPdfUrl] = useState<string>("");
  return (
    <>
    <div
      className="takaful--collapse-profile-container"
      style={{ paddingTop: "1rem" }}
    >
      <div
        className={`takaful--collapse-profile takaful--collapse-label-container takaful--collapse-beneficiary-services  `}
      >
        <Collapse.Panel
          showArrow={false}
          key="0"
          className=" takaful--collapse-label-panel"
          header={
            <div className="takaful--header-profile-container">
              <Row
                className="takaful--content-profile-box1"
                style={{ marginBottom: "0" }}
              >
                <Col
                  xxl={4}
                  xl={4}
                  lg={4}
                  md={4}
                  sm={12}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">الوقف</p>
                </Col>
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    عدد الأسهم{" "}
                  </p>
                </Col>
                <Col
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={5}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">السهم</p>
                </Col>
                <Col
                  xxl={4}
                  xl={4}
                  lg={4}
                  md={4}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">المسار</p>
                </Col>
              </Row>
            </div>
          }
        ></Collapse.Panel>
      </div>
      <Collapse
        className={`takaful--collapse-profile takaful--collapse-beneficiary-services takaful--collapse-sponsor-requests`}
        accordion
        defaultActiveKey={["0"]}
      >
        {requests?.map((element: any, index: number) => (
          <Collapse.Panel
            className="takaful--header-profile-Panel takaful--collapse-label-panel"
            key={index}
            showArrow={false}
            header={
              <div className="takaful--header-profile-container">
                <Row
                  className="takaful--content-profile-box1"
                  style={{
                    marginBottom: "0",
                    paddingLeft: "2rem",
                    paddingRight: "1rem",
                  }}
                >
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={4}
                    sm={0}
                    xs={0}
                    className="takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.palm_endowment_id}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">الوقف</p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.share_number}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">السهم</p>
                  </Col>
                  <Col
                    xxl={5}
                    xl={5}
                    lg={5}
                    md={5}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.share_id}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      المسار
                    </p>
                  </Col>
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={4}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.path_id}
                    </span>
                  </Col>
                </Row>
              </div>
            }
          >
            <div style={{ padding: "0rem 1rem 0rem 1rem" }}>
              <Row className="takaful--content-profile-box1">
                <Col
                  xxl={4}
                  xl={4}
                  lg={4}
                  md={4}
                  sm={24}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">المزرعة</p>
                </Col>
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={24}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <span className="takaful--content-services-request-span takaful--color-span">
                    {element?.farm_id}
                  </span>
                </Col>

                <Col
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={5}
                  sm={24}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    الكود الزراعي
                  </p>
                </Col>
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={24}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <span className="takaful--content-services-request-span takaful--color-span">
                    {element?.code_farm}
                  </span>
                </Col>
              </Row>
              {element?.attachments_ids?.length > 0 && (
                <Row className="takaful--content-profile-box1">
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={24}
                    xs={24}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      المرفقات
                    </p>
                  </Col>
                  <Col
                    xxl={18}
                    xl={18}
                    lg={18}
                    md={18}
                    sm={24}
                    xs={24}
                    className="takaful--content-profile-col"
                  >
                    {element?.attachments_ids.map(
                      (item: string, index: number) => (
                        <span className="takaful--content-services-request-span takaful--color-span">

                        <FileOutlined
                        className="takaful--download-icon takaful--service-download-icon"
                        onClick={(e) => {
                          setPdfUrl(item);
                        }}
                      />{" "}
                      </span>
                      )
                    )}
                  </Col>
                </Row>
              )}
            </div>
          </Collapse.Panel>
        ))}
      </Collapse>
    </div>
        <PdfPreview
        open={pdfUrl !== ""}
        onClose={() => setPdfUrl("")}
        url={pdfUrl}
        isBlob={false}
        className="takaful--pdf-preview-modal"
      />
      </>
  );
};

export default ShareList;
